const getCurrentEnvironment = () => {
  if (typeof window !== 'undefined') {
    if (window?.location?.hostname?.includes('staging')) return 'staging';

    if (window?.location?.hostname?.includes('admin.youngones.works')) return 'production';
  }

  return 'development';
};

export default getCurrentEnvironment;
